import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DocumentList from './DocumentList';  // New import
import BalanceTable from './BalanceTable';  // New import
import Navbar from './Navbar';
import './Navbar.css';

function CommitteeDetail() {
  const { acctNum } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`/api/committees/${acctNum}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setData(result);

        // Set page title using committee name
        document.title = result.Name || 'Committee Detail';
      } catch (err) {
        setError(err.message);
        document.title = 'Committee Not Found';
      } finally {
        setLoading(false);
      }
    };

    if (acctNum) fetchData();
  }, [acctNum]);

  if (loading) return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
      <main style={{ maxWidth: '900px', margin: '18px auto', padding: '24px' }}>
        Loading committee details...
      </main>
    </div>
  );

  if (error || !data) return (
    <div style={{ background: '#fff', minHeight: '100vh', color: '#000' }}>
      <Navbar />
      <main style={{ maxWidth: '900px', margin: '18px auto', padding: '24px' }}>
        <section style={{ padding: '20px', borderRadius: 12, boxShadow: '0 1px 6px rgba(16,24,40,0.04)' }}>
          <h2>Committee Not Found</h2>
          <button onClick={() => navigate(-1)}>Back to List</button>
        </section>
      </main>
    </div>
  );

  // Compute fullChairName if chair fields exist
  const fullChairName = `${data.ChrNameFirst || ''} ${data.ChrNameMiddle ? data.ChrNameMiddle + ' ' : ''}${data.ChrNameLast || ''}`.trim();

  // Prepare fields for table (exclude _id; include computed address and chair)
  const tableData = {
    ...data,
    fullAddress: `${data.Addr1 || ''}${data.Addr2 ? ', ' + data.Addr2 : ''}, ${data.City || ''}, ${data.State || ''} ${data.Zip || ''}`.trim(),
    fullChair: fullChairName || 'N/A'
  };
  delete tableData._id;

  const fields = Object.entries(tableData)
    .filter(([key]) => !key.startsWith('ChrName') && key !== 'TrsNameFirst' && key !== 'TrsNameMiddle' && key !== 'TrsNameLast')  // Exclude raw name parts
    .map(([key, value]) => ({ key: key.replace(/([A-Z])/g, ' $1').trim(), value }));

  return (
    <div style={{ background: '#ffffff', minHeight: '100vh', color: '#000' }}>
      <Navbar />

      <main style={{ maxWidth: '1000px', margin: '18px auto', padding: '24px' }}>
        <section style={{ padding: '20px', borderRadius: 12, boxShadow: '0 1px 6px rgba(16,24,40,0.04)' }}>
          <h2 style={{ marginTop: 0 }}>{data.Name}</h2>

          <table border="1" style={{ borderCollapse: 'collapse', width: '100%', border: '1px solid black' }}>
        <tbody>
          {fields.map(({ key, value }, index) => (
            <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
              <td style={{ width: '30%', padding: '8px', border: '1px solid black', backgroundColor: '#f9f9f9' }}>
                <strong>{key}:</strong>
              </td>
              <td style={{ width: '70%', padding: '8px', border: '1px solid black' }}>
                {value || 'N/A'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
          {/* New: Documents Table */}
          <DocumentList acctNum={acctNum} />
          <BalanceTable accountList={[{ accountName: 'Committee Account', accountNum: parseInt(acctNum) }]} />

          <button onClick={() => navigate('/committees')} style={{ marginTop: '20px' }}>Back to List</button>
        </section>
      </main>
    </div>
  );
}

export default CommitteeDetail;